import { get } from './base'
import qs from 'qs'

const resourceTypesEndpoint = '/api/v2/resource-types'

export function getResourceTypes() {
  return get(resourceTypesEndpoint, {
    params: {
      onlyActiveUnits: false,
    },
    paramsSerializer: (params: { onlyActiveUnits: boolean }) => {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    },
  })
}
